import * as React from 'react';

export default function NoFilterResults() {
  return (
    <div className="no-expos no-filter-results">
      <h3>No results found</h3>
    </div>
  );
}
